export enum ViewType {
  NONE,
  DOR_VIEW = 1,
  THERAPIST_VIEW = 2,
}
